import { createFileRoute } from '@tanstack/react-router'
import DirectDeposit from '../../../../../../components/RefundUIs/DirectDeposit'

export const Route = createFileRoute(
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/direct-deposit',
)({
  component: DirectDeposit,
})
